import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {SurveyFirm} from '../../maintain-firm/survey-firm.model';
import {Observable} from 'rxjs';
import {AppConfigService} from './app-config.service';

@Injectable({
    providedIn: 'root'
})
export class FirmSettingsService {
    title = 'Firm Settings Service';

    constructor(
        private http: HttpClient,
        private appConfigService: AppConfigService
    ) {}

    save(firmSettingsViewModel: SurveyFirm): Observable<SurveyFirm> {
        const url = `${this.appConfigService.settings.apiGatewayUrl}/maintain/firm/save`;
        return this.http.post<SurveyFirm>(url, firmSettingsViewModel);
    }

    load() {
        console.log('load is invoked');
        const url = `${this.appConfigService.settings.apiGatewayUrl}/maintain/firm/load`;
        return this.http.get<SurveyFirm>(url);
    }

    getFirmEmailAddress(): Observable<string> {
        const url = `${this.appConfigService.settings.apiGatewayUrl}/maintain/firm/email`;
        return this.http.get<string>(url);
    }

    getDefaultPdfWatermark() {
        console.debug(`${this.title} - getDefaultPdfWatermark`);
        return this.http.get<string>(`${this.appConfigService.settings.apiGatewayUrl}/maintain/firm/defaultPdfWatermark`);
    }
}
